import ProjectGroup from "../models/ProjectGroup";
import User from "../models/User";
import Project from "../models/Project";
import ProjectPosition from "../models/ProjectPosition";

import TalentCandidate from "../models/TalentCandidate";
import TalentSkill from "../models/TalentSkill";
import Team from "../models/Team";
import TalentPool from "../models/TalentPool";
import Agency from "../models/Agency";


const searchTalentSkills = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};
    let user = TB.auth().user();

    // talent users do not have hasRegisteredClientOrg -> DisciplineSkillsStep.js
    // if (!user || !user.hasRegisteredClientOrg()) {
    if (!user) {
        throw new Error('Unauthorized')
    }
    const skillRequest = TB.request(
        TB.api_endpoint("/api/talent-skills/search"), params
    );

    let response = await skillRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.skills')) {
        throw new Error('Something Went Wrong')
    }

    return TalentSkill.makeMany(response.success.data.skills)
}

const searchTalentBrands = async ({queryKey, signal}) => {
    const search = queryKey[1] || '';
    let user = TB.auth().user();
    if (!user || !user.hasRegisteredClientOrg()) {
        throw new Error('Unauthorized')
    }
    const brandsRequest = TB.request(
        TB.api_endpoint("/api/brands/search"), {search, platform: 1}
    );

    let response = await brandsRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.brands')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data.brands
}

const fetchTalentPools = async({queryKey, signal}) => {
    const {clientId,...params} = queryKey[1] || {};
    const fetchTalentPoolsRequest = TB.request(
        TB.api_endpoint(`/api/clients/${clientId}/talent-pools`),params
    );

    let response = await fetchTalentPoolsRequest.get({signal}).catch(console.warn);

    if (!response || !TB.has(response, 'success.data.client_talent_pools')) {
        throw new Error('Something Went Wrong')
    }

    let pools = TB.map(response.success.data.client_talent_pools, pool => {
        if (pool?.owner) {
            return {
                ...pool, owner: User.make(pool.owner)
            }
        }
        return pool
    })
    return TalentPool.makeMany(pools)
}

const fetchTalentPoolDetail = async({queryKey, signal}) => {
    const { clientId, poolId, ...params } = queryKey[1] || {};
    const fetchTalentPoolDetailRequest = TB.request(
        TB.api_endpoint(`/api/clients/${clientId}/talent-pools/${poolId}/talent-users`), params
    );

    let response = await fetchTalentPoolDetailRequest.get({signal}).catch(console.warn);

    if (!response || (!TB.has(response, 'success.data.talent_users') && !TB.has(response, 'success.data.talent_invites'))) {
        throw new Error('Something Went Wrong')
    }

    return TalentPool.make(response.success.data);
}

const formatSearchForRequest = (queryKey) => {
    let params = queryKey[1] || {};

    params = TB.mapValues(params,val => {
        try {
            return JSON.parse(val);
        } catch {
            return val;
        }
    }, {});
    // console.log('searchForClient', params)
    let user = TB.auth().user();
    let expLevels = TB.map(TB.values(laravel.talent_experience_levels), 'prefix');
    let importanceLevels = TB.map(TB.values(laravel.importance_levels), TB.slugify)
    let acceptedParams = [
        'accomplished_disciplines',
        'per_page',
        'roles',
        'filters_disciplines',
        'filters_skills',
        'filters_industries',
        'filters_experience',
        'filters_brands',
        'shortlisted',
        'sort_by',
        'page',
        'interested',
        'capture_talent_request',
        'favorite',
        'liked',
        'disliked',
        'project_position',
        'partner_programs',
        'service_tags',
        'experience',
        'location',
        'min_score',
        'pool_ids',
        'brands',
        'sort_dir',
        'search',
        'is_not_in_pool_id',
        'is_in_pool_id',
        'favorited',
        'hired',
        'invited',
        'location',
        'regions',
        'latitude',
        'longitude',
        'skills',
        'industries',
        'disciplines',
        'sizes',
        'local_storage',
        'include_fully_booked'
    ];
    TB.map(importanceLevels, level => {
        acceptedParams.push(
            `${TB.snakeCase(level)}_skills`,
            `${TB.snakeCase(level)}_industries`,
            `filters_${TB.snakeCase(level)}_skills`,
            `filters_${TB.snakeCase(level)}_industries`,
        )
    })

    // TB.map(expLevels, level => {
    //     acceptedParams.push(`disciplines`)
    // })


    let formattedParams = TB.pick(params, acceptedParams);

    if (formattedParams['skills']?.length) {
        formattedParams['important_skills'] = formattedParams['skills'];
        delete formattedParams['skills'];
    }

    if (formattedParams['industries']?.length) {
        formattedParams['important_industries'] = formattedParams['industries'];
        delete formattedParams['industries'];
    }


    // parse regions and get countries
    if (formattedParams['regions']?.length) {
        formattedParams['regions'] = TB.map(formattedParams['regions'], region => parseInt(region))
        let regions = user.clientOrg()?.regions || [];
        let selectedRegions = TB.filter(regions, region => formattedParams['regions'].includes(region.id))
        if (selectedRegions) {
            formattedParams['countries'] = TB.flatMap(selectedRegions, 'countries')
        }
        delete formattedParams['regions']
    }

    for (let [key,value] of Object.entries(formattedParams)) {
        if (TB.isArray(value)) {
            if (!value.length) {
                continue;
            }
            value = value.join(',');
        }
        if (key === 'favorite') {
            formattedParams['favorited'] = value;
            continue;
        }
        if (key === 'sizes') {
            let sizes = [];
            TB.map(value, (sizeValue, sizeKey) => {
                if (sizeValue === true) {
                    sizes.push(sizeKey);
                }
            });
            formattedParams['sizes'] = sizes;
            continue;
        }
        if (key === 'location') {

            formattedParams['visibility_setting_location'] = parseInt(value) || null;

            delete formattedParams['location'];

            continue;
        }

        if (key === 'experience') {
            if (!formattedParams['experience']) {
                formattedParams['experience'] = {}
            }
            try {
                TB.map(value, (isChecked, key) => {
                    formattedParams['experience'][key] = isChecked ? 1 : 0;
                })

            }catch (e) {
                console.error(e);
            }
            continue;
        }
        if (key === 'filters_experience' && TB.isObject(value)) {
            TB.map(value, (expValue, expKey) => {
                formattedParams[`${key}_${expKey}`] = expValue ? 1 : 0;
            })
            delete formattedParams['filters_experience'];
            console.log('FILTERSEXPERIENCE', formattedParams);
            continue;
        }
        formattedParams[key] = value;
    }

    if (formattedParams['visibility_setting_location'] === 2 && !formattedParams['countries']?.length) {
        delete formattedParams['visibility_setting_location'];
        delete formattedParams['countries'];
    }else if (formattedParams['visibility_setting_location'] > 3) {
        if (!formattedParams['latitude'] || !formattedParams['longitude']) {
            let position = user?.location || user?.clientOrg()?.location

            if (position) {
                formattedParams['latitude'] = position.latitude;
                formattedParams['longitude'] = position.longitude;
                // console.log("Latitude: " + formattedParams['latitude'] + ", Longitude: " + formattedParams['longitude']);

            } else {
                delete formattedParams['longitude']
                delete formattedParams['latitude']
                delete formattedParams['visibility_setting_location']
                // Geolocation is not available
                // console.log("Geolocation is not supported by your browser");
            }
        }
    }
    return formattedParams;
}

const searchForTalent = async ({queryKey, signal}) => {
    let user = TB.auth().user();
    if (!user || !user.hasRegisteredClientOrg()) {
        throw new Error('Unauthorized')
    }
    const formattedParams = formatSearchForRequest(queryKey);

    // console.log('searchForClient', {expLevels, importanceLevels, acceptedParams, formattedParams});

    const SearchForClientRequest = TB.request(
        TB.api_endpoint(`/api/clients/${user.clientOrg().id}/talent-users`), formattedParams
    );

    let response = await SearchForClientRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.users')) {
        throw new Error('Something Went Wrong')
    }

    return TB.set(response.success.data, 'users', TalentCandidate.makeMany(response.success.data.users));
}

const searchForTeams = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};

    // console.log('Team @ searchForClient', params);

    let user = TB.auth().user();
    if (!user || !user.hasRegisteredClientOrg()) {
        throw new Error('Unauthorized')
    }

    const formattedParams = formatSearchForRequest(queryKey);

    for (let [key, value] of Object.entries(params)) {
        if (TB.isArray(value)) {
            if (!value.length) {
                continue;
            }
            value = value.join(',');
        }
        if (key === 'experience') {
            if (!formattedParams['experience']) {
                formattedParams['experience'] = {}
            }
            try {
                TB.map(value, (isChecked, key) => {
                    formattedParams['experience'][key] = isChecked ? 1 : 0;
                })

            }catch (e) {
                console.error(e);
            }
            continue;
        }
        formattedParams[key] = value;
    }

    const SearchForClientRequest = TB.request(
        TB.api_endpoint(`/api/clients/${user.clientOrg().id}/teams`), formattedParams
    );

    let response = await SearchForClientRequest.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.teams')) {
        throw new Error('Something Went Wrong')
    }


    return TB.set(response.success.data, 'teams', Team.makeMany(response.success.data.teams));
}


const searchForSuppliers = async ({queryKey, signal}) => {

    let user = TB.auth().user();
    if (!user || !user.hasRegisteredClientOrg()) {
        throw new Error('Unauthorized')
    }

    const formattedParams = formatSearchForRequest(queryKey);

    delete formattedParams['sort_by'];
    delete formattedParams['sort_dir'];
    const SearchForClientRequest = TB.request(
        TB.api_endpoint(`/api/clients/${user.clientOrg().id}/suppliers`), formattedParams
    );

    let response = await SearchForClientRequest.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.supplier_clients')) {
        throw new Error('Something Went Wrong')
    }


    return TB.set(response.success.data, 'supplier_clients', Agency.makeMany(response.success.data.supplier_clients));
}

const fetchTalentTimePayments = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};
    let user = TB.auth().user();

    if (!user || !user.hasRegisteredClientOrg()) {
        throw new Error('Unauthorized')
    }

    const request = TB.request(
        TB.api_endpoint(`/api/clients/${user.clientOrg().id}/financials/time-report`),
        params
    );

    let response = await request.get({signal}).catch(e => {
        throw new Error(e.message)
    });

    if (!TB.has(response, 'success.data')) {
        throw new Error('Something Went Wrong')
    }
    return {
        rows: TB.filter(TB.map(TB.cloneDeep(response.success.data.rows), (rowData, index) => {
            return {
                ...rowData,
                id: index
            }
        }), row => parseInt(row.total_hours) > 0)
    }
    // return response.success.data;
};

/**
 * Hydrate a resource's matched talent into the User model.
 *
 * Resources that did not resolve to a platform record are left alone - there is
 * no user to build, and inventing one would make the model's talent checks lie.
 *
 * @param {Object} resource
 * @returns {Object}
 */
const makeResourceUser = (resource) => {
    if (!resource?.user) {
        return resource;
    }

    return {...resource, user: User.make({...resource.user})};
};

const fetchContractProgression = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};
    let user = TB.auth().user();

    if (!user || !user.hasRegisteredClientOrg()) {
        throw new Error('Unauthorized')
    }

    const request = TB.request(
        TB.api_endpoint(`/api/clients/${user.clientOrg().id}/financials/contract-progression`),
        params
    );

    let response = await request.get({signal}).catch(e => {
        throw new Error(e.message)
    });

    if (!TB.has(response, 'success.data')) {
        throw new Error('Something Went Wrong')
    }

    const data = response.success.data;

    return {
        ...data,
        contracts: TB.map(data.contracts || [], contract => ({
            ...contract,
            resources: TB.map(contract.resources || [], makeResourceUser),
            steps: TB.map(contract.steps || [], step => ({
                ...step,
                resources: TB.map(step.resources || [], makeResourceUser),
            })),
        })),
    };
};

const fetchProjectBurnSpend = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};
    let user = TB.auth().user();

    if (!user || !user.hasRegisteredClientOrg()) {
        throw new Error('Unauthorized')
    }

    const request = TB.request(
        TB.api_endpoint(`/api/clients/${user.clientOrg().id}/financials/project-burn-spend`),
        params
    );

    let response = await request.get({signal}).catch(e => {
        throw new Error(e.message)
    });

    if (!TB.has(response, 'success.data')) {
        throw new Error('Something Went Wrong')
    }

    const data = response.success.data;

    return {
        ...data,
        projects: TB.map(data.projects || [], project => ({
            ...project,
            positions: TB.map(project.positions || [], position => ({
                ...position,
                consultants: TB.map(position.consultants || [], makeResourceUser),
            })),
        })),
    };
};


const fetchClientProjectGroups = ({queryKey, signal}) => {
    const client_id = queryKey[1] || {};

    return ProjectGroup.fetchAllForClient(client_id,{signal})
}


const fetchClientUsers = async({queryKey, signal}) => {
    const client_id = queryKey[1] || {};

    let response = await User.fetchAllForClient({signal});
    if(!response) {
        throw new Error(User.FetchAllForClientRequest)
    }

    return response;
}

const fetchProject = async({queryKey, signal}) => {
    const project_id = queryKey[1] || {};  // queryKey[0] is the original query key 'infinite-posts'

    return Project.fetchForClient(project_id, false,{signal})
}
const searchProjectKeywords = async({queryKey, signal}) => {
    const query = queryKey[1] || {};
    return Project.searchKeywords(query, {signal})
}


const fetchGreenlightOptionsForCandidate = async({queryKey, signal}) => {
    const query = queryKey[1] || {};

    const {
        position_id,
        project_id,
        status,
        page,
        per_page
    } = query;
    return ProjectPosition.fetchGreenlightOptionsForCandidate(
        project_id, position_id, {status, page, per_page}, {signal}
    )
}

const fetchTalentPoolActiveProjects = async({queryKey, signal}) => {
    const { clientId, poolId, ...params } = queryKey[1] || {};
    const request = TB.request(
        TB.api_endpoint(`/api/clients/${clientId}/talent-pools/${poolId}/projects/active`), { ...params }
    );

    let response = await request.get({signal}).catch(console.warn);

    if (!response || !TB.has(response, 'success.data.projects')) {
        throw new Error('Something Went Wrong')
    }

    let { current_page, last_page, total, projects } = response.success.data;

    projects = TB.map(projects, project => {
        project.limited = true;
        return Project.adjustPropsOnFetched(project);
    });

    return {
        current_page, last_page, total, requisitions: Project.makeMany(projects)
    }
}

/**
 * The in-network talent's live engagements with this client, used by the Rehire flow's Change
 * Order path to pick which position is being amended.
 */
const fetchTalentUserActivePositions = async({queryKey, signal}) => {
    const { clientId, poolId, talentUserId, ...params } = queryKey[1] || {};

    const request = TB.request(
        TB.api_endpoint(
            `/api/clients/${clientId}/talent-pools/${poolId}/talent-users/${talentUserId}/active-positions`
        ), { ...params }
    );

    let response = await request.get({signal}).catch(console.warn);

    if (!response || !TB.has(response, 'success.data.positions')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data.positions || [];
}

const fetchClientProjects = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};
    const projects = await Project.fetchAllForClient(params, true, {signal});
    if (!projects) {
        throw new Error('Failed to load projects');
    }
    return projects;
}

export {
    fetchClientProjects,
    fetchClientProjectGroups,
    fetchProject,
    fetchClientUsers,
    fetchTalentPools,
    fetchTalentPoolDetail,
    fetchTalentPoolActiveProjects,
    fetchTalentUserActivePositions,
    searchProjectKeywords,
    fetchGreenlightOptionsForCandidate,
    searchForTalent,
    searchForTeams,
    searchForSuppliers,
    searchTalentSkills,
    searchTalentBrands,
    fetchTalentTimePayments,
    fetchContractProgression,
    fetchProjectBurnSpend,
}